import React, { useState } from "react";
import { Button, Table } from "react-bootstrap";

import { useFetchAutoNewsStatisticQuery } from "../../store/api/apiSlice";

const AutoNewsStatistics = () => {
  const { data: AutonewsData } = useFetchAutoNewsStatisticQuery({});

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(AutonewsData?.cron_job_query_stats?.length / itemsPerPage);

  const paginatedKeys = AutonewsData?.cron_job_query_stats.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Function to generate page numbers with `...`
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 10;

    if (totalPages <= maxVisiblePages) {
      // If total pages are less than or equal to maxVisiblePages, show all pages
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Always show the first page
      pageNumbers.push(1);

      // Show pages around the current page
      const startPage = Math.max(2, currentPage - 2);
      const endPage = Math.min(totalPages - 1, currentPage + 2);

      if (startPage > 2) {
        pageNumbers.push("...");
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      if (endPage < totalPages - 1) {
        pageNumbers.push("...");
      }

      // Always show the last page
      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  return (
    <>
      <div className="pb-4 gap-4 pt-4 keyManagement_cont"></div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>University</th>
            <th>Query</th>
            <th>Fetched</th>
            <th>Inserted</th>
            <th>Date Time</th>
          </tr>
        </thead>
        <tbody>
          {paginatedKeys?.map((key) => (
            <tr key={key._id}>
              <td>{key.university}</td>
              <td>{key.query}</td>
              <td>{key.total_google_response}</td>
              <td>{key.total_news_inserted}</td>
              <td>{key.createdAt}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="d-flex justify-content-center mt-3">
        {getPageNumbers().map((page, index) => (
          <Button
            key={index}
            variant={currentPage === page ? "primary" : "outline-primary"}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className="mx-1"
            disabled={page === "..."} // Disable the "..." button
          >
            {page}
          </Button>
        ))}
      </div>
    </>
  );
};

export default AutoNewsStatistics;